import React from "react";
import CompanyInfo from "../components/CompanyInfo";
import "./styles/AboutPage.css";
import Navbar from "../components/Navbar";
import { HeroSectionAbout } from "../components/HeroSection";
import Footer from "../components/Footer";
import data from "../data/imageData.json";
import ResponsiveImage from "../components/ResponsiveImage";

const AboutPage = () => {
  return (
    <div className="aboutPage">
      <div className="header">
        <ResponsiveImage src={data.aboutpage.url} alt="" className="heroImage" priority />
      <Navbar />
        <HeroSectionAbout />

      </div>
      <main className="content">
        <CompanyInfo />
        <div className="aboutCompany">
          <h3>Data infiintare: 2018</h3>
          <h3>CUI: 40167645</h3>
          <h3>Nr. de înregistrare: J36/692/2018</h3>
          <h3>EUID: ROONRC.J36/692/2018</h3>
          <p>Aflati mai multe <a href="https://www.listafirme.ro/sercons-contractor-srl-40167645/" target="_blank" rel="noreferrer">aici</a></p>
        </div>
      </main>
      <Footer />
    </div>
  );
};

export default AboutPage;
